module.exports = __webpack_public_path__ + "gp.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/gp.svg
// module id = 575
// module chunks = 0